import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { sortCaloriesInAscendingOrder } from '../helpers/mealCaloriesModalHelpers';
import { useDispatch } from 'react-redux';
import {
  getCaloriesModal,
  getCurrentDiscountDetails,
  getMealExchangeActiveDay,
} from '../../../../redux/selectors/orderFormSelector';
import {
  mealExchangeResetCaloriesModal,
  mealExchangeUpdateDayPriceAdjustment,
} from '../../../../redux/actions/orderFormActions';
import { exchangeMeal, scrollToNextMeal } from '../helpers/mealExchangeHelpers';
import { getSelectedCity } from '../../../../redux/selectors/summaryReducer.selectors';
import Modal from 'react-modal';
import { customFind } from '../../../../utils';
import { getMealExchangeSinglePrice } from '../../../../utils/orderFormPrices';
import { getServerConfig } from '../../../../features/general/generalSlice';
import Coins2Icon from '../../../../assets/icons/coins2Icon';
import { nanoid } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../../config/hooks';

const MealCaloriesModal = ({ companyName, refs }) => {
  const dispatch = useDispatch();
  const {
    id,
    mealId,
    mealPrice,
    menuMealName,
    modalStatus,
    otherCaloriesMenuMeals,
  } = useAppSelector(getCaloriesModal) || {};
  const activeDay = useAppSelector(getMealExchangeActiveDay);
  const { sectorId } = useAppSelector(getSelectedCity);
  const currentDiscountDetails = useAppSelector(getCurrentDiscountDetails);
  const { apiKey, serverUrl } = useAppSelector(getServerConfig);

  const closeModal = () => {
    dispatch(mealExchangeResetCaloriesModal());
  };

  const parseCaloriePrice = price => {
    if (price === 0) {
      return `0 zł`;
    }
    if (price > 0) {
      return `+${price.toFixed(2)} zł`;
    }
    return `${price.toFixed(2)} zł`;
  };

  return (
    <Modal
      className="meal-calories-modal"
      isOpen={modalStatus}
      onRequestClose={closeModal}
      overlayClassName="overlay-form-fixed"
    >
      <FontAwesomeIcon
        className="meal-calories-modal__close font-size-20"
        icon={faTimes}
        onClick={closeModal}
      />
      <h3 className="meal-calories-modal__title">Zmień kaloryczność</h3>
      <p className="body-m spacer-bottom-40">{menuMealName}</p>
      {[...otherCaloriesMenuMeals]
        .sort(sortCaloriesInAscendingOrder)
        ?.map(item => {
          const {
            calories,
            ingredientCalories,
            ingredientCarbohydrate,
            ingredientFat,
            ingredientProtein,
            menuMealId,
            prices,
          } = item;

          const findMealPriceBySector = customFind(
            'sectorId',
            sectorId
          )(prices)?.additionPrice;

          const price = findMealPriceBySector - mealPrice;

          return (
            findMealPriceBySector && (
              <div
                className="meal-calories-modal__card"
                key={nanoid()}
                onClick={() => {
                  dispatch(
                    exchangeMeal(
                      companyName,
                      activeDay,
                      id,
                      item,
                      mealId,
                      serverUrl,
                      apiKey
                    )
                  );
                  dispatch(
                    mealExchangeUpdateDayPriceAdjustment(price, 'meals')
                  );
                  scrollToNextMeal(refs, id);
                }}
                onKeyDown={() => {
                  dispatch(
                    exchangeMeal(
                      companyName,
                      activeDay,
                      id,
                      item,
                      mealId,
                      serverUrl,
                      apiKey
                    )
                  );
                  dispatch(
                    mealExchangeUpdateDayPriceAdjustment(price, 'meals')
                  );
                  scrollToNextMeal(refs, id);
                }}
                role="button"
                tabIndex={0}
              >
                <h6 className="label-l spacer-bottom-4">
                  Posiłek z diety {calories} kcal{' '}
                  {!menuMealId && (
                    <>
                      <br />
                      <span className="body-m">
                        Danie nie zostało jeszcze ustalone przez catering
                      </span>
                    </>
                  )}
                </h6>
                <div className="display-flex align-items-center justify-content-space-between">
                  {menuMealId ? (
                    <p className="body-m color-gray-400">
                      {ingredientCalories}kcal • B: {ingredientProtein}g • W:{' '}
                      {ingredientCarbohydrate}g • T: {ingredientFat}g
                    </p>
                  ) : (
                    <div />
                  )}
                  <div className="display-flex align-items-center spacer-left-6 flex-shrink-0">
                    <Coins2Icon height="16" width="16" />
                    <span className="label-m color-primary spacer-left-4">
                      {parseCaloriePrice(
                        getMealExchangeSinglePrice(
                          price,
                          currentDiscountDetails
                        )
                      )}
                    </span>
                  </div>
                </div>
              </div>
            )
          );
        })}
    </Modal>
  );
};

MealCaloriesModal.propTypes = {
  companyName: PropTypes.string.isRequired,
  refs: PropTypes.object,
};

export default MealCaloriesModal;
